export const MessageIcon = ({ ...rest }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#7C3AED"
        fillOpacity="0.1"
      />
      <path
        d="M28.3333 15.8333L20.8408 20.6058C20.5866 20.7535 20.2978 20.8313 20.0038 20.8313C19.7097 20.8313 19.4209 20.7535 19.1667 20.6058L11.6667 15.8333"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6667 13.3333H13.3333C12.4129 13.3333 11.6667 14.0795 11.6667 15V25C11.6667 25.9205 12.4129 26.6667 13.3333 26.6667H26.6667C27.5871 26.6667 28.3333 25.9205 28.3333 25V15C28.3333 14.0795 27.5871 13.3333 26.6667 13.3333Z"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
